import { Checkbox, Typography } from '@attentive-platform/stem-ui';
import { Checkbox as OldCheckbox } from '../../uilib';
import { isBeamUser } from '../../Utils/HelperFunctions';

export const ConstructionUserFlag = ({ isSet, onChange }) => {
  if (isBeamUser()) {
    return (
      <OldCheckbox
        color='secondary'
        checked={isSet}
        onChange={e => onChange({ is_construction_signup: e.target.checked })}
        label='Construction Sign Up'
      />
    );
  }

  return (
    <div className='flex items-center gap-0'>
      <Checkbox
        color='secondary'
        checked={isSet}
        onChange={e => onChange({ is_construction_signup: e.target.checked })}
        className='mr-0'
      />
      <Typography variant='body3'>Construction Sign Up</Typography>
    </div>
  );
};

export const WelcomeEmailFlag = ({ isSet, onChange }) => {
  if (isBeamUser()) {
    return (
      <OldCheckbox
        color='secondary'
        checked={isSet}
        onChange={e => onChange({ send_welcome_email: e.target.checked })}
        label='Send user a welcome email with reset link'
      />
    );
  }

  return (
    <div className='flex items-center gap-0'>
      <Checkbox
        color='secondary'
        checked={isSet}
        onChange={e => onChange({ send_welcome_email: e.target.checked })}
        className='mr-0'
      />
      <Typography variant='body3'>Send user a welcome email with reset link</Typography>
    </div>
  );
};
